
define('modules/application/wizard/classes/genericEnabler',[
  "app",

  // Libs
  "backbone",

  //Classes
  "./genericElement"

],

function(app, Backbone, genericElement) {

  var genericEnabler   = _.extend({}, genericElement, {

    Views       : {

      titleBar  : genericElement.Views.titleBar.extend({
        template: "application/wizard/sections/genericEnabler/titleBar",
        tagName : "h3",

        initialize                     : function() {
          this.model.bind("change:value", this.setLabel, this);
          this.model.bind("render:requested", this.setLabel, this);
          this.model.set("titleBarView",this);
        },

        setLabel                      : function() {
          var value = this.model.get("value") ? "IDS_W1_9047" : "IDS_W1_9048";
          if ( (this.model.get("enabled")) && (value) )
          {
            this.$el.find(".caption").html($.i18n._(value));
            this.$el.find(".caption").fadeIn(200);
          }
          else
            this.$el.find(".caption").fadeOut(200, function() {$(this).hide();});
        },

        enable                        : function() {
          this.$el.trigger("click");
          this.$el.find(".caption").fadeIn(200);
        },

        disable                       : function() {
          this.$el.trigger("click");
          this.$el.find(".caption").fadeOut(200, function() {$(this).hide();});
        },

        removeLabel                   : function() {
          this.$el.find(".caption").fadeOut(200, function() {$(this).hide();});
        },

        onClose: function(){
          this.model.unbind("updateViews", this.setLabel);
        }
      }),

      content   : genericElement.Views.content.extend({
        template                      : "application/wizard/sections/genericEnabler/content",
        className                     : "genericEnabler",
        events                        : {
          "click .radio"  : "updateValue"
        },

        serialize                     : function() {
          return genericElement.Views.content.prototype.serialize.apply(this);
        },

        initialize                     : function() {
          this.model.unbind("updateViews", this.updateSpinners);
          this.model.bind("updateViews", this.updateSpinners, this);

          this.model.unbind("render:requested", this.render);
          this.model.bind("render:requested", this.render, this);

          this.model.set("contentView",this);
        },
        toggleInfos: function(e, currentScope) {
          return genericElement.Views.content.prototype.toggleInfos(e, currentScope);
        },
        updateValue                    : function() {
          var enabled   = (this.$el.find("input[name=\"status\"]:checked").val()==="true");
          if (enabled)
            this.model.enable();
          else
            this.model.disable();
        },

        disableSection                 : function() {
          if (!this.model.get("enabled"))
            this.$el.find(".mainValue").addClass("disabled");
        },

        enableSection                  : function() {
          if (this.model.get("enabled"))
            this.$el.find(".mainValue").removeClass("disabled");
        },

        onClose                        : function(){
          this.model.unbind("updateViews", this.setLabel);
        },
        afterRender                    : function(){
          window.customizeFormElements.call();
        }
      })

    },

    Model       : genericElement.Model.extend({

      defaults                        : {
        enabled         : false,
        value           : false
      },

      initialize                      : function() {

        //Bind on accessory line selection
        window.BticinoS4B.eventAggregator.bind('accessoryLine:chosen',    this.accessoryLineChosenEventHandler,   this);

        //Bind on accessory line removal
        window.BticinoS4B.eventAggregator.bind('accessoryLine:removed',   this.disableSection,  this);

        window.BticinoS4B.eventAggregator.bind("load:Project",            this.loadProject,     this);

        //Bind on materials overview model delivery request
        window.BticinoS4B.eventAggregator.bind("modelDeliver:request",    this.deliverModel,    this);

        if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"))
          this.accessoryLineChosenEventHandler();

      },

      accessoryLineChosenEventHandler : function() {
        this.retrieveProducts();
        this.enableSection();
      },

      enable                          : function() {
        this.set("value", true);
      },

      disable                         : function() {
        this.set("value", false);
      },

      disableSection                  : function() {
        var that = this;

        this.set("enabled",false);
        this.get("contentView").disableSection();
        this.get("titleBarView").removeLabel();
        if(this.get("contentView").isOpen())
          this.get("titleBarView").disable();
      },

      enableSection                   : function() {
        var that = this;
        this.set("enabled",true);
      }
    })

  });

  // Required, return the module for AMD compliance
  return genericEnabler;

});